import { render } from "./ConsultingBigSizeTextModal.vue?vue&type=template&id=79f74204&scoped=true"
import script from "./ConsultingBigSizeTextModal.vue?vue&type=script&lang=js"
export * from "./ConsultingBigSizeTextModal.vue?vue&type=script&lang=js"

import "./ConsultingBigSizeTextModal.vue?vue&type=style&index=0&id=79f74204&scoped=true&lang=css"

import exportComponent from "C:\\Users\\user\\Desktop\\project\\sparta\\sparta-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79f74204"]])

export default __exports__